import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { wrapUrlSafe } from 'utils/language_support_util';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import * as styles from './Link.module.scss';

type Props = {
  className?: string;
  variant: 'primary' | 'secondary'; // there is no gray per Carey in Denali
  href: string;
  onClick?: () => void;
  target?: '_blank';
  rel?: string;
};

function Link({ children, className, href, onClick, rel, target, variant }: PropsWithChildren<Props>) {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <a
      className={classNames(variant && styles[variant], className)}
      href={href.startsWith('https://') || href.startsWith('#') || href.startsWith('mailto:') ? href : wrapUrlSafe(href, languageRegionCode)}
      onClick={onClick}
      {...(target ? { target } : {})}
      {...(rel ? { rel } : {})}
    >
      {children}
    </a>
  );
}

export default Link;
